import React from 'react';
import { Pressable } from 'react-native';
import { View, SxProp, useDripsyTheme } from 'dripsy';

import { TextCaption, TextBody } from '../typography/UniTypography';
import { Icon } from '../icons/Icon';
import { useUploader } from './useUploader.hook';

export interface UniUploaderProps {
  documentType?: string;
  isError?: boolean;
  onDocumentSelected?: (document: any) => void;
}

export const UniUploader = ({ documentType, isError }: UniUploaderProps) => {
  const { theme } = useDripsyTheme();
  const { selectedDocument, pickDocument, removeDocument } = useUploader({ documentType });

  return (
    <View>
      <Pressable onPress={pickDocument}>
        {({ hovered, pressed }) => {
          let viewSx = sxStyles.container;
          if (isError) {
            viewSx = { ...sxStyles.container, ...sxStyles.containerError };
          } else if (hovered || pressed) {
            viewSx = { ...sxStyles.container, ...sxStyles.containerPressed };
          } else {
            viewSx = { ...sxStyles.container, ...sxStyles.containerDefault };
          }

          return (
            <View sx={viewSx}>
              <Icon name="upload" color={pressed && theme.colors.$textButtonOutline} />
              <TextCaption secondary sx={{ color: pressed && '$textButtonOutline' }}>
                Tap this area to upload
              </TextCaption>
            </View>
          );
        }}
      </Pressable>
      {selectedDocument && selectedDocument.type !== 'cancel' && (
        <Pressable onPress={removeDocument}>
          {({ pressed }) => {
            return (
              <View sx={sxStyles.uploadDetails}>
                <TextBody>{selectedDocument.name}</TextBody>
                <Icon name="deleteicon" color={pressed && theme.colors.$iconFocused} />
              </View>
            );
          }}
        </Pressable>
      )}
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  container: {
    height: 120,
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 5,
    justifyContent: 'center',
    alignItems: 'center'
  },
  containerDefault: {
    borderColor: '$borderPrimary'
  },
  containerPressed: {
    borderColor: '$textButtonOutline'
  },
  containerError: {
    borderColor: '$danger'
  },
  uploadText: {
    fontSize: '$0',
    color: '$textBody'
  },
  uploadDetails: {
    mt: 8,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
};
